/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  CancelDailyActivityMonitoringLogHeader,
  CompleteDailyActivityMonitoringLogHeader,
  CreateDailyActivityMonitoringLogHeader,
  CreateDailyActivityMonitoringLogHeaderDto,
  DailyActivityMonitoringLogFileDto,
  DailyActivityMonitoringLogHeaderDto,
  FileDto,
  ListOfConcernsIssueSummaryDto,
  ListOfFileDto,
  PagedResultOfDailyActivityMonitoringLogHeaderSummaryDto,
  SaveDailyActivityMonitoringLogHeader,
  SearchDailyActivityMonitoringLogHeadersParams,
  SubmitDailyActivityMonitoringLogHeader,
  UploadFileDailyActivityMonitoringLogHeadersBody
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns a paged list of dailyactivitymonitoringlogheaders matching the supplied filter and sort criteria.
 */
export const searchDailyActivityMonitoringLogHeaders = (
    params?: SearchDailyActivityMonitoringLogHeadersParams,
 options?: SecondParameter<typeof customInstance<PagedResultOfDailyActivityMonitoringLogHeaderSummaryDto>>,) => {
      return customInstance<PagedResultOfDailyActivityMonitoringLogHeaderSummaryDto>(
      {url: `/deployment/daily-activity-monitoring-log-headers`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Creates a new DailyActivityMonitoringLogHeader from the supplied command.
 */
export const createDailyActivityMonitoringLogHeader = (
    createDailyActivityMonitoringLogHeader: CreateDailyActivityMonitoringLogHeader,
 options?: SecondParameter<typeof customInstance<CreateDailyActivityMonitoringLogHeaderDto>>,) => {
      return customInstance<CreateDailyActivityMonitoringLogHeaderDto>(
      {url: `/deployment/daily-activity-monitoring-log-headers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDailyActivityMonitoringLogHeader
    },
      options);
    }
  /**
 * @summary Returns the DailyActivityMonitoringLogHeader identified by the route id.
 */
export const getDailyActivityMonitoringLogHeaderById = (
    id: string,
 options?: SecondParameter<typeof customInstance<DailyActivityMonitoringLogHeaderDto>>,) => {
      return customInstance<DailyActivityMonitoringLogHeaderDto>(
      {url: `/deployment/daily-activity-monitoring-log-headers/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Replaces the data of the DailyActivityMonitoringLogHeader identified by the route id.
 */
export const saveDailyActivityMonitoringLogHeader = (
    id: string,
    saveDailyActivityMonitoringLogHeader: SaveDailyActivityMonitoringLogHeader,
 options?: SecondParameter<typeof customInstance<DailyActivityMonitoringLogHeaderDto>>,) => {
      return customInstance<DailyActivityMonitoringLogHeaderDto>(
      {url: `/deployment/daily-activity-monitoring-log-headers/${id}/save`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveDailyActivityMonitoringLogHeader
    },
      options);
    }
  /**
 * @summary SubmitDailyActivityMonitoringLogHeader
 */
export const submitDailyActivityMonitoringLogHeader = (
    id: string,
    submitDailyActivityMonitoringLogHeader: SubmitDailyActivityMonitoringLogHeader,
 options?: SecondParameter<typeof customInstance<DailyActivityMonitoringLogHeaderDto>>,) => {
      return customInstance<DailyActivityMonitoringLogHeaderDto>(
      {url: `/deployment/daily-activity-monitoring-log-headers/${id}/submit`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: submitDailyActivityMonitoringLogHeader
    },
      options);
    }
  /**
 * @summary CompleteDailyActivityMonitoringLogHeader
 */
export const completeDailyActivityMonitoringLogHeader = (
    id: string,
    completeDailyActivityMonitoringLogHeader: CompleteDailyActivityMonitoringLogHeader,
 options?: SecondParameter<typeof customInstance<DailyActivityMonitoringLogHeaderDto>>,) => {
      return customInstance<DailyActivityMonitoringLogHeaderDto>(
      {url: `/deployment/daily-activity-monitoring-log-headers/${id}/complete`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: completeDailyActivityMonitoringLogHeader
    },
      options);
    }
  /**
 * @summary CancelDailyActivityMonitoringLogHeader
 */
export const cancelDailyActivityMonitoringLogHeader = (
    id: string,
    cancelDailyActivityMonitoringLogHeader: CancelDailyActivityMonitoringLogHeader,
 options?: SecondParameter<typeof customInstance<DailyActivityMonitoringLogHeaderDto>>,) => {
      return customInstance<DailyActivityMonitoringLogHeaderDto>(
      {url: `/deployment/daily-activity-monitoring-log-headers/${id}/cancel`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: cancelDailyActivityMonitoringLogHeader
    },
      options);
    }
  /**
 * @summary Uploads a small file against the IncidentRecord identified by the route incidentRecordId.
 */
export const uploadFileDailyActivityMonitoringLogHeaders = (
    id: string,
    uploadFileDailyActivityMonitoringLogHeadersBody: UploadFileDailyActivityMonitoringLogHeadersBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {const formData = new FormData();
if(uploadFileDailyActivityMonitoringLogHeadersBody.file !== undefined) {
 formData.append(`file`, uploadFileDailyActivityMonitoringLogHeadersBody.file);
 }

      return customInstance<void>(
      {url: `/deployment/daily-activity-monitoring-log-headers/${id}/files`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  /**
 * @summary Lists every file uploaded against the IncidentRecord identified by the route incidentRecordId.
 */
export const getDailyActivityMonitoringLogFiles = (
    id: string,
 options?: SecondParameter<typeof customInstance<ListOfFileDto>>,) => {
      return customInstance<ListOfFileDto>(
      {url: `/deployment/daily-activity-monitoring-log-headers/${id}/files`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Returns the Concerns/Issues recorded against the Daily Activity Monitoring Log detail identified by the route id, while its parent log is still Draft. Backs the "Manage Concerns" modal, which needs to see its own entries regardless of what a general Concerns/Issues search does with Draft-log entries.
 */
export const getDailyActivityMonitoringLogConcernsIssues = (
    id: string,
 options?: SecondParameter<typeof customInstance<ListOfConcernsIssueSummaryDto>>,) => {
      return customInstance<ListOfConcernsIssueSummaryDto>(
      {url: `/deployment/daily-activity-monitoring-log-headers/${id}/concerns`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Returns the metadata of the file identified by the route fileId, uploaded against the IncidentRecord identified by incidentRecordId.
 */
export const getDailyActivityMonitoringLogFile = (
    id: string,
    fileId: string,
 options?: SecondParameter<typeof customInstance<FileDto>>,) => {
      return customInstance<FileDto>(
      {url: `/deployment/daily-activity-monitoring-log-headers/${id}/files/${fileId}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Deletes the file associated with the transmittal document identified by the route documentId and fileId.
 */
export const deleteDailyActivityMonitoringLogFile = (
    id: string,
    fileId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/deployment/daily-activity-monitoring-log-headers/${id}/files/${fileId}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Downloads the content of the file identified by the route fileId, uploaded against the IncidentRecord identified by incidentRecordId.
 */
export const downloadDailyActivityMonitoringLogFile = (
    id: string,
    fileId: string,
 options?: SecondParameter<typeof customInstance<DailyActivityMonitoringLogFileDto>>,) => {
      return customInstance<DailyActivityMonitoringLogFileDto>(
      {url: `/deployment/daily-activity-monitoring-log-headers/${id}/files/${fileId}/content`, method: 'GET'
    },
      options);
    }
  export type SearchDailyActivityMonitoringLogHeadersResult = NonNullable<Awaited<ReturnType<typeof searchDailyActivityMonitoringLogHeaders>>>
export type CreateDailyActivityMonitoringLogHeaderResult = NonNullable<Awaited<ReturnType<typeof createDailyActivityMonitoringLogHeader>>>
export type GetDailyActivityMonitoringLogHeaderByIdResult = NonNullable<Awaited<ReturnType<typeof getDailyActivityMonitoringLogHeaderById>>>
export type SaveDailyActivityMonitoringLogHeaderResult = NonNullable<Awaited<ReturnType<typeof saveDailyActivityMonitoringLogHeader>>>
export type SubmitDailyActivityMonitoringLogHeaderResult = NonNullable<Awaited<ReturnType<typeof submitDailyActivityMonitoringLogHeader>>>
export type CompleteDailyActivityMonitoringLogHeaderResult = NonNullable<Awaited<ReturnType<typeof completeDailyActivityMonitoringLogHeader>>>
export type CancelDailyActivityMonitoringLogHeaderResult = NonNullable<Awaited<ReturnType<typeof cancelDailyActivityMonitoringLogHeader>>>
export type UploadFileDailyActivityMonitoringLogHeadersResult = NonNullable<Awaited<ReturnType<typeof uploadFileDailyActivityMonitoringLogHeaders>>>
export type GetDailyActivityMonitoringLogFilesResult = NonNullable<Awaited<ReturnType<typeof getDailyActivityMonitoringLogFiles>>>
export type GetDailyActivityMonitoringLogConcernsIssuesResult = NonNullable<Awaited<ReturnType<typeof getDailyActivityMonitoringLogConcernsIssues>>>
export type GetDailyActivityMonitoringLogFileResult = NonNullable<Awaited<ReturnType<typeof getDailyActivityMonitoringLogFile>>>
export type DeleteDailyActivityMonitoringLogFileResult = NonNullable<Awaited<ReturnType<typeof deleteDailyActivityMonitoringLogFile>>>
export type DownloadDailyActivityMonitoringLogFileResult = NonNullable<Awaited<ReturnType<typeof downloadDailyActivityMonitoringLogFile>>>
